import React from "react";
import { Card, CardContent, Typography, Stack, Divider } from "@mui/material";

export default function DoorSummary(props) {
    const { darkState, doorOrderList } = props;

    return (
        <Card
            variant="outlined"
            sx={{
                my: 1,
                width: "100%",
                border: darkState ? "1.5px solid" : "3px solid",
                borderColor: "primary.main",
                borderRadius: 2,
            }}
        >
            <CardContent
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                }}
            >
                <div>
                    <Typography
                        variant="h3"
                        color="text.primary"
                        gutterBottom
                        sx={{
                            fontWeight: 700,
                            fontSize: { xs: "2rem", sm: "2.5rem" }, // Larger font size
                            textAlign: "center",
                        }}
                    >
                        {`${doorOrderList.length} ${
                            doorOrderList.length === 1 ? "DOOR" : "DOORS"
                        }`}
                    </Typography>
                    <Divider sx={{ my: 1, width: "100%" }} />
                    <Stack direction="row" spacing={2}>
                        <Stack alignItems="center">
                            <Typography
                                variant="body1"
                                color="warning.main"
                                sx={{
                                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                    fontWeight: 500,
                                    textAlign: "center",
                                }}
                            >
                                RH Doors
                            </Typography>
                            <Typography
                                variant="h6"
                                color="warning.main"
                                sx={{
                                    fontWeight: 600,
                                    fontSize: { xs: "1.25rem", sm: "1.5rem" },
                                }}
                            >
                                {`${
                                    doorOrderList.filter(
                                        (door) => door.hand === "RH"
                                    ).length
                                }`}
                            </Typography>
                        </Stack>
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{
                                display: { xs: "none", sm: "block" },
                                my: { xs: 1, sm: 0 },
                            }}
                        />
                        <Stack alignItems="center">
                            <Typography
                                variant="body1"
                                color="warning.main"
                                sx={{
                                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                    fontWeight: 500,
                                    textAlign: "center",
                                }}
                            >
                                LH Doors
                            </Typography>
                            <Typography
                                variant="h6"
                                color="warning.main"
                                sx={{
                                    fontWeight: 600,
                                    fontSize: { xs: "1.25rem", sm: "1.5rem" },
                                }}
                            >
                                {`${
                                    doorOrderList.filter(
                                        (door) => door.hand === "LH"
                                    ).length
                                }`}
                            </Typography>
                        </Stack>
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{
                                display: { xs: "none", sm: "block" },
                                my: { xs: 1, sm: 0 },
                            }}
                        />
                        <Stack alignItems="center">
                            <Typography
                                variant="body1"
                                color="warning.main"
                                sx={{
                                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                    fontWeight: 500,
                                    textAlign: "center",
                                }}
                            >
                                LHA Doors
                            </Typography>
                            <Typography
                                variant="h6"
                                color="warning.main"
                                sx={{
                                    fontWeight: 600,
                                    fontSize: { xs: "1.25rem", sm: "1.5rem" },
                                }}
                            >
                                {`${
                                    doorOrderList.filter(
                                        (door) => door.hand === "LHA"
                                    ).length
                                }`}
                            </Typography>
                        </Stack>
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{
                                display: { xs: "none", sm: "block" },
                                my: { xs: 1, sm: 0 },
                            }}
                        />
                        <Stack alignItems="center">
                            <Typography
                                variant="body1"
                                color="warning.main"
                                sx={{
                                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                    fontWeight: 500,
                                    textAlign: "center",
                                }}
                            >
                                RHA Doors
                            </Typography>
                            <Typography
                                variant="h6"
                                color="warning.main"
                                sx={{
                                    fontWeight: 600,
                                    fontSize: { xs: "1.25rem", sm: "1.5rem" },
                                }}
                            >
                                {`${
                                    doorOrderList.filter(
                                        (door) => door.hand === "RHA"
                                    ).length
                                }`}
                            </Typography>
                        </Stack>
                    </Stack>
                </div>
            </CardContent>
        </Card>
    );
}
